const env = window?.location?.host?.includes('dev.') ? 'dev-' : ''

const API_HOST = process.env.NODE_ENV === 'development' ? 'http://localhost:3001/smart/catalog/' : `https://${env}io.winwinapp.ru/smart/catalog/`

export default  {
  API_HOST
}
